import { Download, RectangleHorizontal, Square, RectangleVertical } from "lucide-react";
import { fileUrl } from "../../lib/api";
import { useLang } from "../../lib/i18n";

const FORMATS = [
  { id: "original", icon: RectangleHorizontal },
  { id: "square", icon: Square },
  { id: "vertical", icon: RectangleVertical },
];

export const ExportTab = ({ project, format, setFormat, onExport, disabled }) => {
  const { t } = useLang();
  const exports = [...(project.exports || [])].reverse();
  return (
    <div className="frz-tabpane" data-testid="tabpane-export">
      <h4 className="frz-label">{t("format")}</h4>
      <div className="frz-formats">
        {FORMATS.map(({ id, icon: Icon }) => (
          <button key={id} type="button" className={`frz-format ${format === id ? "on" : ""}`} onClick={() => setFormat(id)} data-testid={`format-${id}`}>
            <Icon size={22} />
            <span>{t(`fmt_${id}`)}</span>
          </button>
        ))}
      </div>
      <p className="frz-hint">{t("export_note")}</p>
      <button type="button" className="frz-btn frz-btn-primary frz-btn-block" onClick={onExport} disabled={disabled} data-testid="button-export-download">
        <Download size={16} /> {t("export_btn")}
      </button>
      {exports.length > 0 && (
        <>
          <h4 className="frz-label">{t("exports")}</h4>
          <ul className="frz-exports" data-testid="exports-list">
            {exports.map((e, i) => (
              <li key={e.created_at}>
                <span>{t(`fmt_${e.format}`)} · {e.file?.width}×{e.file?.height}</span>
                <a href={fileUrl(e.file, true)} className="frz-link" data-testid={`export-download-${i}`}>{t("download")}</a>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
